<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container>
      <base-material-card
        v-if="reliabilities"
        icon="mdi-clipboard-text-outline"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("reliability.list") }}
            <export-2-excel
              :filename="`meru-realiability-list-${equipmentProfile.equipTag}`"
              sheetname="realiability-list"
              :datos="exportDatos"
            ></export-2-excel>
          </div>
        </template>

        <v-btn
          @click="
            $router.push({
              name: 'New/Reliability',
              params: { equipId: $route.params.id }
            })
          "
          v-if="$store.getters['auth/reliabilityWrite']"
          fab
          color="primary"
          absolute=""
          top
          right=""
          ><v-icon color="white">mdi-plus</v-icon></v-btn
        >
        <v-data-table
          @click:row="rowClick"
          :headers="headers"
          :items="reliabilities"
          sort-by="datetime"
          sort-desc=""
          :footer-props="{
            itemsPerPageText: $t('repairList.itemsPerPage'),
            itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
          }"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-icon
              :color="
                item.status && item.status.trafficLight
                  ? item.status.trafficLight.color
                  : item.status.color
                  ? item.status.color
                  : '#008450'
              "
              >mdi-circle</v-icon
            >

            {{
              item.status && item.status.trafficLight
                ? translate(item.status.trafficLight.name)
                : item.status.name
                ? translate(item.status.name)
                : $t("reliability.statuslights.running")
            }}
          </template>

          <template v-slot:[`item.datetime`]="{ item }">
            {{
              (item.datetime || item.status.datetime)
                | formatDate(user.language)
                | capitalize
            }}</template
          >
        </v-data-table>
      </base-material-card>
    </v-container></v-container
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},

  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "reliabilities/bindRealibilityOfEquipment",
      this.$route.params.id
    );

    loading.close();
  },
  data() {
    return {
      search: this.$route.params.equipTag,
      headers: [
        {
          text: this.$t("reliability.status"),
          value: "status"
        },
        {
          text: this.$t("reliability.repairDate"),
          value: "datetime"
        }
      ]
    };
  },

  computed: {
    exportDatos() {
      if (this.reliabilities) {
        const header = this.headers.map(h => {
          return h.text;
        });
        const mapedData = this.reliabilities.map(e => {
          const resume =
            e.status && e.status.trafficLight
              ? e.status.trafficLight.name
              : e.status.name
              ? e.status.name
              : "Running";
          const dateCreated = new Intl.DateTimeFormat("es-VE").format(
            e.datetime?.toDate() || e.status.datetime.toDate()
          );
          return [resume, dateCreated];
        });
        const datos = [
          ["Equipment Tag", this.equipmentProfile.equipTag],
          [...header],
          ...mapedData
        ];
        return datos;
      } else return [["Server", "Error"]];
    },
    ...mapState("auth", ["user"]),
    ...mapState("reliabilities", ["reliabilities"]),
    ...mapState("equipments", ["equipmentProfile"])
  },
  methods: {
    rowClick: function(item) {
      this.$router.push({
        name: "ReliabilityProfile",
        params: { id: item.id }
      });
      //item  - selected item
    },
    translate: function(item) {
      var temp = item;

      temp = temp.replace(
        "Running",
        this.$t("reliability.statuslights.running")
      );
      temp = temp.replace(
        "Standby",
        this.$t("reliability.statuslights.standby")
      );
      temp = temp.replace(
        "Maintenance",
        this.$t("reliability.statuslights.maintenance")
      );
      temp = temp.replace(
        "Failure",
        this.$t("reliability.statuslights.failure")
      );

      temp = temp.replace("Smooth", this.$t("reliability.conditions.smooth"));
      temp = temp.replace("Warning", this.$t("reliability.conditions.warning"));
      temp = temp.replace("Alarm", this.$t("reliability.conditions.alarm"));

      return temp;
    }
  }
};
</script>
